// extracted by mini-css-extract-plugin
export var additional = "_7y-4";
export var event = "_7y-1";
export var eventMain = "_7y-2";
export var line = "_7y-3";
export var point = "_7y-7";
export var subtitle = "_7y-6 _s-0";
export var timeline = "_7y-0";
export var title = "_7y-5 _s-0";